'use strict';

var angular = require('angular');
var dependencies = ['ui.router', 'ngCookies', 'AVRO.Widgets.Combobox'];
module.exports = angular.module('AVRO.Userlanding.SelectCarrier', dependencies).config(require('./config/SelectCarrierConfig')).controller('SelectCarrierController', require('./controllers/SelectCarrierController'));